import i18n from "@/lang";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { AuthenticationState } from "./state";

export default {
    isUserSuperAdmin: (state: AuthenticationState) => {
        if (
            state.currentUser != null &&
            state.currentUser.profile != null &&
            state.currentUser.profile.privileges != null &&
            state.currentUser.profile.privileges.privilegeName != null &&
            state.currentUser.profile.privileges.privilegeName.includes(ClientPrivileges.SuperAdmin.privilegeName)
        )
            return true;
        else return false;
    },

    authUserHasPrivilege: (state: AuthenticationState) => (privilege: ClientPrivileges) =>
        state.currentUser && state.currentUser.profile.privileges.and(privilege) != ClientPrivileges.None,
    userDateFormat: (state: AuthenticationState) => {
        if (state.currentUser == null || state.currentUser.userConfig == null || state.currentUser.userConfig.dateFormat == null) return "YYYY-MM-DD";
        return state.currentUser.userConfig.dateFormat;
    },
    userTimeFormat: (state: AuthenticationState) => {
        if (
            state.currentUser == null ||
            state.currentUser.userConfig == null ||
            state.currentUser.userConfig.timeFormat == null ||
            state.currentUser.userConfig.timeFormat == "ampm"
        )
            return { pickerFormat: "ampm", timeFormat: "hh:mm A", timeFormatWithSec: "hh:mm:ss A" };
        return { pickerFormat: "24hr", timeFormat: "HH:mm", timeFormatWithSec: "HH:mm:ss" };
    },
    longDateFormat:
        (_, getters) => (withTime: boolean, fourD: boolean, fourM: boolean, withoutDay: boolean, withoutSeconds: boolean, withConjunction: boolean, withoutDayNumber: boolean) => {
            let formatString = "";
            if (fourD) formatString = "dddd, ";
            else formatString = "ddd, ";
            if (withoutDay) formatString = "";
            if (fourM) formatString += `${getters.userDateFormat.replace("MM", "MMMM").replace(/-/g, " ")}`;
            else formatString += `${getters.userDateFormat.replace("MM", "MMM").replace(/-/g, " ")}`;
            if (withTime)
                if (withoutSeconds) formatString += `, ${getters.userTimeFormat.timeFormat}`;
                else formatString += `, ${getters.userTimeFormat.timeFormatWithSec}`;

            if (withConjunction) formatString = formatString.replace(",", ` [${i18n.t("common.at")}]`);

            if (withoutDayNumber) formatString = formatString.replace("DD", "");
            return formatString;
        },
    notificationEnabled: (state: AuthenticationState) => {
        return (
            state.currentUser.profile.privileges.and(ClientPrivileges.SecurityManagement) != ClientPrivileges.None ||
            state.currentUser.profile.privileges.and(ClientPrivileges.RollsConfigurationManagement) != ClientPrivileges.None ||
            state.currentUser.profile.privileges.and(ClientPrivileges.CaosConfigurationManagement) != ClientPrivileges.None ||
            state.currentUser.profile.privileges.and(ClientPrivileges.UpdatesManagement) != ClientPrivileges.None ||
            state.currentUser.profile.privileges.and(ClientPrivileges.SmartLockActivation) != ClientPrivileges.None ||
            state.currentUser.profile.privileges.and(ClientPrivileges.SmartLockManagement) != ClientPrivileges.None
        );
    },
};
